import React from 'react'
import { IoCheckmarkCircleSharp } from 'react-icons/io5'
import styled from 'styled-components'
import { Link } from 'lib/Link'
import { Text } from 'lib/Text'
import { useCurrentBrand } from './context/CurrentBrandProvider'

const Container = styled.div`
  border: 1px solid var(--neutral-20);
  margin-top: 20px;
`

const InnerContainer = styled.div`
  padding: 32px;
  position: relative;

  :not(:last-child) {
    border-bottom: 1px solid var(--neutral-20);
  }
`

const InfoText = styled(Text)`
  line-height: 18px;
`

const StyledLink = styled(Link)`
  color: var(--neutral-60);
  display: inline-block;
  line-height: 14px;
`

const CheckmarkIcon = styled(IoCheckmarkCircleSharp)`
  display: inline-block;
  vertical-align: bottom;
  margin-right: 4px;
`

export const TransparencyBox = () => {
  const {
    brand: { slug, claimed, title }
  } = useCurrentBrand()

  return (
    <Container>
      <InnerContainer>
        {claimed ? (
          <>
            <Text size="ps" weight="semi" margin="1x">
              <CheckmarkIcon size={24} /> This brand page has been claimed
            </Text>
            <InfoText size="pxs" color="neutral-60" margin="1x">
              Brands claim their brand page to verify and update company details but cannot influence or delete reviews.{' '}
              <StyledLink href="/about">Read more</StyledLink>.
            </InfoText>
            <InfoText size="pxs" color="neutral-60">
              If you work at {title}, <StyledLink href={`/brands/${slug}/contribute`}>apply to be a contributor</StyledLink>.
            </InfoText>
          </>
        ) : (
          <>
            <Text size="ps" weight="bold" margin="1x">
              This brand page has not been claimed yet
            </Text>
            <InfoText size="pxs" color="neutral-60" margin="1x">
              Verifying your brand page ensures your company details are accurate.
            </InfoText>
            <InfoText size="pxs" color="neutral-60">
              If you work at {title}, go here to <StyledLink href={`/brands/${slug}/contribute`}>claim your brand page</StyledLink>.
            </InfoText>
          </>
        )}
      </InnerContainer>
    </Container>
  )
}
